
<!--
    @name: 工程公司搜索
-->
<template>
  <div :style="{ paddingTop: top ? '10px' : 0 }">
    <ScreenSort
      @changeobj="changeobj"
      :config="['aptitudeType','enterpriseType','locationAddress','engineeringScreen']"
    ></ScreenSort>
    <!-- 列表 -->
    <div class="table" v-loading="loadingTrue">
      <div style="padding: 0 20px 10px 20px">
        <el-row :gutter="20" v-if="teamList.length">
          <el-col v-for="(item, index) in teamList" :span="12" :key="index">
            <card :item="item" :type="2"></card>
          </el-col>
            <template>
              <el-col :span="24" class="course-loading-wrap" v-if="moreLoading">
                数据加载中... <i class="el-icon-loading loading-icon"></i>
              </el-col>
              <el-col :span="24" class="course-loading-wrap" v-if="!moreLoading && nomore">没有更多数据了!</el-col>
            </template>
        </el-row>

        <!-- 无数据显示缺省图 -->
        <div
          v-if="!teamList.length && !loadingTrue"
          style="width: 1200px; margin: 0 auto; margin-bottom: 10px"
        >
          <BaseEmptyData></BaseEmptyData>
        </div>
      </div>
    </div>
    <!-- <Pagination
      v-if="param.total > 0 && !loadingTrue"
      :param="param"
      @change="getlist"
      :loadingTrue="loadingTrue"
    ></Pagination> -->
  </div>
</template>
<script>
import { apiEngineeringCompany } from "@/api/apiEngineeringCompany"
const throttle = require("lodash/throttle");
export default {
  name: "engineeringCompany",
  components: {
    ScreenSort: () => import("@/components/screenSort/screenSort"),
    Pagination: () => import("@/components/card/page"),
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"),
    card: () => import("@/components/card/cardEngineeringCompany.vue")
  },
  props: {
    top: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingTrue: true,
      moreLoading: false, //加载更多
      nomore: false, //没有数据显示
      // 请求参数
      params: {},
      // 卡片列表
      teamList: [],
      param: {
        page: 1,
        limit: 40,
        total: 0,
        totalPages: 0
      }
    }
  },
   watch: {
    // 页数改变的时候
    "param.page": {
      handler(val) {
        if (val > this.param.totalPages) {
          this.nomore = true;
        } else {
          this.nomore = false;
        }
      },
    },
   },
  methods: {
    // 获取列表数据
    getlist() {
      this.moreLoading = true //加载更多显示
      let params = { ...this.params }
      params.page = this.param.page
      params.limit = this.param.limit
      if(process.env.VUE_APP_NAME ==="production"){
        params.profile='pro'
      }else if(process.env.VUE_APP_NAME==='pre'){
        params.profile='pro'
      }else if(process.env.VUE_APP_NAME==='development'){
        params.profile='dev'
      }
      this.teamList = []
      apiEngineeringCompany.list(params).then(res => {
        this.loadingTrue = false
        if (res && res.data && res.data.code === 200) {
          this.param.total = res.data.data.total
          this.$parent.count5 = res.data.data.total
          this.param.totalPages=res.data.data.pages;
          this.teamList = [...this.teamList,...res.data.data.records] 
          this.moreLoading = false //加载更多隐藏
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
        // 页面滚动
    windowScroll: throttle(
      function () {
        // 如果当前页数大于总页数 则不去获取
        let scrollTop =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          document.body.scrollTop;
        let scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;
        let clientHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        /**
         * clientHeight 视口大小
         * scrollHeight 文档高度
         */
        if (scrollTop + clientHeight >= scrollHeight - 300) {
          this.param.page += 1;
          if (this.param.page <= this.param.totalPages) {
            this.getlist()
          }
        }
      },
      1500,
      { leading: false, trailing: true }
    ),
    changeobj(obj) {
      this.param.page = 1
      this.teamList=[]
      this.loadingTrue=true
      for (let i in this.params) {
        this.params[i] = ""
      }
      let t = this
      ;[
        "firstCategoryNo",
        "secondCategoryNo",
        "thirdCategoryNo",
        "fourCategoryNo",
        "fifthCategoryNo",
        "sixthCategoryNo"
      ].forEach((v, i) => {
        if (obj.secondCategory) {
          t.params[v] = obj.secondCategory[i] ? obj.secondCategory[i].no : ""
        } else {
          t.params[v] = ""
        }
      })
      this.params.teamNumber =
        obj.teamSize && obj.teamSize[0] ? obj.teamSize[0].ranges : ""
      this.params.provinceNo = obj.locationAddresscode.provinceId
      this.params.cityNo = obj.locationAddress?obj.locationAddresscode.cityId:'';
      this.params.areaNoList = obj.locationAddress
        ? obj.locationAddress.map(v => {
            return v.no
          })
        : []
      if(obj.locationAddresscode.isAll){
        this.params.areaNoList=this.params.areaNoList[0]
      }
      //获取搜索值
      this.params.keyWord = localStorage.getItem("search_query")
      this.params. qualifyTypeNo=obj.aptitudeType?obj.aptitudeType[0].no:'';//资质类型
      this.params. qualifyLevelNo=obj.aptitudeType&&obj.aptitudeType[1]?obj.aptitudeType[1].no:'';//资质等级
      this.params. companyProperties=obj.enterpriseType&&obj.enterpriseType[0]?obj.enterpriseType[0].label:'';//股东性质
      if(obj.engineeringScreen){
        obj.engineeringScreen.map(v=>{
           if(v.key=='achievement'){//业绩
          if(v.no==4){
            this.params.teamResultNum="5000万-10000万"
          }else if(v.no==5){
            this.params.teamResultNum="10000万以上"
          }else{
            this.params. teamResultNum=v.name
          }
          }
          if(v.key=='filings')this.params.placeOfFilingNo=v.filingsSecondNo//备案地
          if(v.key=='domicile'){
            this.params.registerProvinceNo=v.provinceNo;//注册地省
            this.params.registerCityNo=v.cityNo;//注册地市
            this.params. registerAreaNoList=v.areaNo;//注册地区
          }
        })
      }
      this.getlist()
    },
    getList() {
      this.param.page = 1
      this.teamList=[]
      this.loadingTrue=true
      this.getlist()
    }
  },
   mounted() {
    document.addEventListener("scroll", this.windowScroll);
  },
    beforeDestroy() {
    document.removeEventListener("scroll",  this.windowScroll);
  },
  provide() {
    return {
      cardListCom: this
    }
  }
}
</script>
<style lang="scss"  scoped>
.table {
  position: relative;
  width: 1200px;
  margin: 10px auto 0;
  overflow: hidden;
  min-height: 400px;
  background: white;
  border: 1px solid #e4e7ed;
}
.course-loading-wrap {
    display: flex;
    padding-top: 10px;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    color: #999;
    background: #fff;
    .loading-icon {
      margin-left: 12px;
      font-size: 24px;
    }
  }
</style>
